import { MessageCircle } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { trackWhatsAppClick, trackGoogleAdsWhatsAppClick } from "@/lib/gtm";

export const WhatsAppButton = () => {
  const { language } = useLanguage();
  const phoneNumber = "31638523131"; // +31 6 38523131 formatted for WhatsApp
  
  const messages = {
    tr: "Merhaba! Saç ekimi hakkında bilgi almak istiyorum.",
    en: "Hello! I'm interested in learning more about hair transplant procedures.",
    nl: "Hallo! Ik wil graag meer informatie over haartransplantatie.",
    fr: "Bonjour! Je souhaite en savoir plus sur la greffe de cheveux.",
    ar: "مرحباً! أرغب في معرفة المزيد عن زراعة الشعر.",
  };

  const tooltips = {
    tr: "WhatsApp ile İletişim",
    en: "Chat on WhatsApp",
    nl: "Chat via WhatsApp",
    fr: "Discuter sur WhatsApp",
    ar: "تواصل عبر واتساب",
  };

  const message = messages[language as keyof typeof messages] || messages.tr;
  const tooltip = tooltips[language as keyof typeof tooltips] || tooltips.tr;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  const handleClick = () => {
    // Legacy tracking (still respects GTM consent mode)
    trackWhatsAppClick('floating_button');
    trackGoogleAdsWhatsAppClick('floating_button');
    
  };

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed top-32 right-4 z-[60] group"
      aria-label={tooltip}
      onClick={handleClick}
    >
      <div className="relative">
        {/* Pulse animation ring */}
        <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-75 group-hover:opacity-0 transition-opacity" />
        
        {/* Main button */}
        <div className="relative w-12 h-12 md:w-14 md:h-14 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group-hover:scale-110">
          <MessageCircle className="w-6 h-6 md:w-7 md:h-7 text-white" fill="white" />
        </div>
      </div>
      
      {/* Tooltip */}
      <div className="absolute top-1/2 -translate-y-1/2 right-full mr-3 px-3 py-2 bg-foreground text-background text-sm font-medium rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-lg">
        {tooltip}
        <div className="absolute top-1/2 -translate-y-1/2 left-full w-2 h-2 bg-foreground transform rotate-45 -ml-1" />
      </div>
    </a>
  );
};
